import script from "./submit9.vue?vue&type=script&setup=true&lang=js"
export * from "./submit9.vue?vue&type=script&setup=true&lang=js"

import "./submit9.vue?vue&type=style&index=0&id=491b0042&scoped=true&lang=css"

import exportComponent from "D:\\doc\\project\\lunwenzhinengtougaopingtaitest2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-491b0042"]])

export default __exports__